import Swiper from 'swiper';
import {Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
let swiperInstances = [];

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
    handleSwiperInit();
});

function handleSwiperInit() {
    const isMobile = window.innerWidth <= 1023;
    const blocks = document.querySelectorAll('.advantages-grid-block');

    if (isMobile) {
        // If mobile and no swipers initialized, initialize them
        if (swiperInstances.length === 0) {
            blocks.forEach((block) => {
                const container = block.querySelector('.swiper');
                if (!container) return;

                const swiper = new Swiper(container, {
                    modules: [Pagination],
                    spaceBetween: '16px',
                    slidesPerView: 1,
                    pagination: {
                        el: block.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                    },
                });
                swiperInstances.push(swiper);
            });
        }

    } else {
        // If desktop and swipers are initialized, destroy them
        if (swiperInstances.length > 0) {
            swiperInstances.forEach((swiper) => {
                if (typeof swiper.destroy === 'function') {
                    swiper.destroy(true, true);
                }
            });
            swiperInstances = [];
        }
    }
}
